<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>賦能 Solution</h2>
            <h2 style="padding-top: 10px;">N-Cour 永續淨零平台</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start About Area -->
<section class="about-area ptb-50">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3>Ｃ-4 碳知決策</h3>
            </div>
        </div>
    </div>
</section>
<!-- End About Area -->
<section class="features-area">
    <div class="container" style="max-width: 90%;">
        <div class="section-title">
            <h2>實踐淨零戰略，企業永續十大關鍵賦能</h2>
        </div>
        <div>
            <div>
                <img src="assets/img/esg/地球2.gif" alt="image" class="image">
                <div class="text-overlay">
                    <p>碳知起點 永續奇點</p>
                    <p>Enhance innate greatnes</p>
                </div>
            </div>
            <div class="col-lg-6"></div>
        </div>
        <div class="features-list-area">
            <ul class="features-list">
                <li><span><i class='bx bx-check-double'></i>淨零源動力</span></li>
                <li><span><i class='bx bx-check-double'></i>數位洞察力</span></li>
                <li><span><i class='bx bx-check-double'></i>轉型核心力</span></li>
                <li><span><i class='bx bx-check-double'></i>變革包容力</span></li>
                <li><span><i class='bx bx-check-double'></i>品牌創新力</span></li>
            </ul>
            <ul class="features-list">
                <li><span><i class='bx bx-check-double'></i>行動續航力</span></li>
                <li><span><i class='bx bx-check-double'></i>綠色影響力</span></li>
                <li><span><i class='bx bx-check-double'></i>共識凝聚力</span></li>
                <li><span><i class='bx bx-check-double'></i>知識變現力</span></li>
                <li><span><i class='bx bx-check-double'></i>鏈結協作力</span></li>
            </ul>
        </div>
    </div>
</section>


<section class="about-area ptb-50">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3>N-Cour 永續淨零平台</h3>
                <!-- <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p> -->
            </div>
        </div>
    </div>
</section>

<section class="features-area">
    <div class="container" style="max-width: 100%;padding-left: 0px;padding-right: 0px;background-color: white;">
        <div class="section-title center">
            <h2>C-4碳知決策</h2>
            <p>迎接淨零碳排時代，N-Cour C-4碳知決策以「轉型創勢 化零為韌」為發展方向，協助企業建構智能化、標準化、創新化的智能碳管理系統，實踐淨零碳排和永續發展目標。</p>
        </div>

        <div style="text-align: center;padding-top: 0px;" class="ptb-50">
            <a style="display: inline;">
                <img class="ad" src="assets/img/esg/nCour.png">
            </a>
        </div>

    </div>
</section>

<section class="features-area">
    <div class="container" style="max-width: 100%;padding-left: 0px;padding-right: 0px;background-color: white;">
        <div class="section-title">
            <h2>符合溫室氣體盤查流程，優化企業碳盤作業程序</h2>
        </div>

        <div style="text-align: center;padding-top: 0px;" class="ptb-50">
            <a style="display: inline;">
                <img class="ad" src="assets/img/esg/邊.png">
            </a>
        </div>
    </div>
</section>

<section class="about-area ptb-50">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3>N-Cour碳知決策</h3>
                <!-- <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p> -->
            </div>
        </div>
    </div>
</section>

<section class="features-area">
    <div class="container" style="max-width: 100%;padding-left: 0px;padding-right: 0px;background-color: white;">
        <div class="section-title">
            <h2>系統功能</h2>
        </div>

        <div style="text-align: center;padding-top: 0px;" class="ptb-50">
            <a style="display: inline;">
                <img class="ad" src="assets/img/esg/functions.png">
            </a>
        </div>
    </div>
</section>


<section class="service-area service-area-two middle ptb-20">
    <section class="row center">
        <div class="col-sm-12 col-lg-12">
            <section class="service-area row flex-wrap">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="container">
                        <div class="highlight flex-wrap2">
                            <h3>標準與合規
                            </h3>
                            <p>
                                依循國際標準制定盤查流程與作業規範，接軌全球標準，減輕合規負擔。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="container">
                        <div class="highlight flex-wrap2">
                            <h3>整合與共治
                            </h3>
                            <p>
                                整合異質碳數據來源，提高盤查資料的準確性；串連企業內外部系統，實現永續發展管理。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="container">
                        <div class="highlight flex-wrap2">
                            <h3>智能與數據
                            </h3>
                            <p>
                                建立淨零碳排指標與績效監控，獲取減碳數據洞察，擬定淨零碳排行動計劃。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="container">
                        <div class="highlight flex-wrap2">
                            <h3>創新與應用
                            </h3>
                            <p>
                                應用數位智能工具，強化企業韌性，打造永續價值鏈，創造企業永續未來。
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </section>
</section>

<section class="about-area ptb-50">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3>平台優勢</h3>
            </div>
        </div>
    </div>
</section>

<section class="features-area">
    <div class="container" style="max-width: 100%;padding-left: 0px;padding-right: 0px;background-color: white;">
        <!-- <div class="section-title">
            <h2>下一代營運模式 NGOM</h2>
            <p>攜手，我們一起開創下一個十年計劃</p>
        </div> -->

        <div style="text-align: center;padding-top: 0px;" class="ptb-20">
            <a style="display: inline;">
                <img class="ad" src="assets/img/esg/special.png">
                <!-- <img class="ad" src="assets/img/esg/6.png"> -->
            </a>
        </div>

    </div>
</section>